import XLSX from 'xlsx';
import { formatDateShortMon } from '../../../Functions';

export function PickUpExcel(data, branchName) {
    var wb = XLSX.utils.book_new();

    // Header
    var ws = XLSX.utils.json_to_sheet([{}], { header: [], skipHeader: true });

    XLSX.utils.sheet_add_json(ws, [{ A: "", B: "Branch: " + branchName, }], { header: [], skipHeader: true, origin: -1 });

    XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", }], { header: [], skipHeader: true, origin: -1 });

    var formatterDate = formatDateShortMon(data[0].date);

    XLSX.utils.sheet_add_json(ws, [
        {
            A: "No.", B: formatterDate, C: "Customer", D: "Destination",
            E: "Address", F: "Trucker", G: "Plate No",
            H: "Container No", I: "Booking No", J: "Service Mode",
            K: "Remarks"
        }
    ], { header: [], skipHeader: true, origin: -1 });

    for (let i = 0; i < data.length; i++) {
        XLSX.utils.sheet_add_json(ws, [
            {
                A: i + 1, B: data[i].status, C: data[i].customer, D: data[i].destination,
                E: data[i].address, F: data[i].trucker, G: data[i].plateNum,
                H: data[i].containerVanNum, I: data[i].bookingRef, J: data[i].modeOfDelivery,
                K: data[i].remarks
            }
        ], { header: [], skipHeader: true, origin: -1 });
    }
    var wscols = [
        { wch: 4 }, // No
        { wch: 15 }, // Date and Remark
        { wch: 25 }, // Customer
        { wch: 9 }, // Destination
        { wch: 35 }, // Address
        { wch: 30 }, // Trucker
        { wch: 25 }, // Plate No
        { wch: 25 }, // Container No
        { wch: 15 }, // Booking No
        { wch: 11 }, // Service Mode
        { wch: 25 }, // Remarks
    ];

    ws['!cols'] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, "Pick-up List");

    XLSX.writeFile(wb, "PickUpList.xlsx")
}